import { useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

import { alertService } from '../../../../shared/services/alertService';
import { usePlanningWizard } from '../PlanningWizardContext';

/**
 * Step 5 — Approval Level 1 / Level 2 (Angular approvalStepSubmit). Level 2 is
 * hidden for StaffType 134 (DIET Principal). Approver lists come from the
 * resolved options (which already apply the StaffType overrides).
 */
const StepApproval = () => {
  const {
    options,
    staffType,
    level1Approver,
    setLevel1Approver,
    level2Approver,
    setLevel2Approver,
    nextPage,
    previousPage,
    confirmationDetails,
  } = usePlanningWizard();

  const [submitted, setSubmitted] = useState(false);

  const approvalStepSubmit = () => {
    setSubmitted(true);
    if (level1Approver) {
      confirmationDetails();
      nextPage();
    } else {
      alertService.error('Please select approval level 1');
    }
  };

  return (
    <div className="card p-4">
      <div className="row">
        <div className="col-6">
          <label className="inMandatory">Approval Level 1</label>
          <Dropdown
            value={level1Approver}
            options={options.level1}
            optionLabel="label"
            optionValue="value"
            placeholder="Select.."
            showClear={!!level1Approver}
            appendTo="self"
            className="w-100"
            onChange={(e) => setLevel1Approver(e.value ?? '')}
          />
          {submitted && !level1Approver && (
            <small className="p-error d-block mt-1">
              Approval level 1 is required
            </small>
          )}
        </div>
        {staffType !== '134' && (
          <div className="col-6">
            <label
            //  className="inMandatory"
            >
              Approval Level 2
            </label>
            <Dropdown
              value={level2Approver}
              options={options.level2}
              optionLabel="label"
              optionValue="value"
              placeholder="Select.."
              showClear={!!level2Approver}
              appendTo="self"
              className="w-100"
              onChange={(e) => setLevel2Approver(e.value ?? '')}
            />
            {/* {submitted && !level2Approver && (
              <small className="p-error d-block mt-1">
                Approval level 2 is required
              </small>
            )} */}
          </div>
        )}
      </div>

      <div className="row mt-4">
        <div className="col-6">
          <Button
            type="button"
            icon="pi pi-angle-left"
            label="Previous"
            className="p-button-danger"
            onClick={previousPage}
          />
        </div>
        <div className="col-6 text-end">
          <Button
            type="button"
            icon="pi pi-angle-right"
            iconPos="right"
            label="Next"
            className="p-button-success"
            onClick={approvalStepSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default StepApproval;
